<script setup>

</script>

<template>
  <div>
    <!-- head -->
    <div class="section section--head">
      <div class="container">
        <div class="row">
          <!-- title -->
          <div class="col-12 col-md-10 offset-md-1 col-lg-6 offset-lg-3">
            <div class="section__title">
              <h1>Arbitrage pools</h1>
              <p>Join arbitrage pools and unlock the potential of partnership to maximize returns from cryptocurrency arbitrage.</p>
            </div>
          </div>
          <!-- end title -->
        </div>
      </div>
    </div>
    <!-- end head -->

    <!-- about -->
    <div class="section section--pb">
      <div class="container">
        <div class="row row--relative">
          <div class="col-12">
            <div class="about">
              <h2 class="about__title">What is Arbitrage Pools?</h2>

              <p class="about__text">Welcome to our Arbitrage Pools – an innovative and collaborative approach to cryptocurrency trading that empowers investors to harness the potential of arbitrage trading as a collective force. Arbitrage Pools bring together like-minded individuals seeking to amplify their profits while minimizing individual risk.</p>

              <p class="about__text">Arbitrage Pools are carefully curated groups of investors who pool their resources to collectively engage in cryptocurrency arbitrage trading. This strategy leverages the price discrepancies between various exchanges, allowing investors to capitalize on market inefficiencies.</p>

              <!-- design elements -->
              <span class="block-icon block-icon--purple">
							<i class="ti ti-topology-star-2"></i>
						</span>
              <span class="screw screw--lines-bl"></span>
              <span class="screw screw--lines-br"></span>
              <span class="screw screw--lines-tr"></span>
            </div>
          </div>

          <!-- animation background -->
          <div class="section__canvas section__canvas--page section__canvas--first" id="canvas"></div>
        </div>
      </div>
    </div>
    <!-- end about -->

    <!-- arbitrage pools -->
    <div class="section">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-4">
            <!-- arbitrage pool -->
            <div class="apool">
              <h3 class="apool__title">Maximum</h3>

              <!-- tabs nav -->
              <ul class="nav nav-tabs apool__tabs apool__tabs--orange" id="apool__tabs1" role="tablist">
                <li class="nav-item" role="presentation">
                  <button class="active" data-bs-toggle="tab" data-bs-target="#atab-1" type="button" role="tab" aria-controls="atab-1" aria-selected="true">2 months</button>
                </li>

                <li class="nav-item" role="presentation">
                  <button data-bs-toggle="tab" data-bs-target="#atab-2" type="button" role="tab" aria-controls="atab-2" aria-selected="false">6 months</button>
                </li>
              </ul>
              <!-- tabs nav -->

              <!-- tabs content -->
              <div class="tab-content">
                <div class="tab-pane fade show active" id="atab-1" role="tabpanel">
                  <div class="apool__content">
                    <span class="apool__value">$500 - $2500</span>
                    <span class="apool__profit">Daily profit (%): <b>0.35</b></span>
                  </div>
                </div>

                <div class="tab-pane fade" id="atab-2" role="tabpanel">
                  <div class="apool__content">
                    <span class="apool__value">$800 - $3000</span>
                    <span class="apool__profit">Daily profit (%): <b>0.42</b></span>
                  </div>
                </div>
              </div>
              <!-- end tabs content -->

              <div class="apool__group">
                <label for="pool1" class="apool__label">Enter amount</label>
                <input id="pool1" name="pool1" type="text" class="apool__input">
              </div>

              <button class="apool__btn" data-bs-target="#modal-apool" type="button" data-bs-toggle="modal">Invest</button>

              <!-- design elements -->
              <span class="block-icon block-icon--orange">
							<i class="ti ti-database-dollar"></i>
						</span>
              <span class="screw screw--lines-tr"></span>
            </div>
            <!-- end arbitrage pool -->
          </div>

          <div class="col-12 col-md-6 col-lg-4">
            <!-- arbitrage pool -->
            <div class="apool">
              <h3 class="apool__title">Standard</h3>

              <!-- tabs nav -->
              <ul class="nav nav-tabs apool__tabs apool__tabs--green" id="apool__tabs2" role="tablist">
                <li class="nav-item" role="presentation">
                  <button class="active" data-bs-toggle="tab" data-bs-target="#atab-3" type="button" role="tab" aria-controls="atab-3" aria-selected="true">7 weeks</button>
                </li>

                <li class="nav-item" role="presentation">
                  <button data-bs-toggle="tab" data-bs-target="#atab-4" type="button" role="tab" aria-controls="atab-4" aria-selected="false">20 weeks</button>
                </li>
              </ul>
              <!-- tabs nav -->

              <!-- tabs content -->
              <div class="tab-content">
                <div class="tab-pane fade show active" id="atab-3" role="tabpanel">
                  <div class="apool__content">
                    <span class="apool__value">$400 - $2000</span>
                    <span class="apool__profit">Daily profit (%): <b>0.31</b></span>
                  </div>
                </div>

                <div class="tab-pane fade" id="atab-4" role="tabpanel">
                  <div class="apool__content">
                    <span class="apool__value">$600 - $2500</span>
                    <span class="apool__profit">Daily profit (%): <b>0.37</b></span>
                  </div>
                </div>
              </div>
              <!-- end tabs content -->

              <div class="apool__group">
                <label for="pool2" class="apool__label">Enter amount</label>
                <input id="pool2" name="pool2" type="text" class="apool__input">
              </div>

              <button class="apool__btn" data-bs-target="#modal-apool" type="button" data-bs-toggle="modal">Invest</button>

              <!-- design elements -->
              <span class="block-icon block-icon--green">
							<i class="ti ti-database-dollar"></i>
						</span>
              <span class="screw screw--lines-tr"></span>
            </div>
            <!-- end arbitrage pool -->
          </div>

          <div class="col-12 col-lg-4">
            <!-- arbitrage pool -->
            <div class="apool">
              <h3 class="apool__title">Lite</h3>

              <!-- tabs nav -->
              <ul class="nav nav-tabs apool__tabs apool__tabs--blue" id="apool__tabs3" role="tablist">
                <li class="nav-item" role="presentation">
                  <button class="active" data-bs-toggle="tab" data-bs-target="#atab-5" type="button" role="tab" aria-controls="atab-5" aria-selected="true">30 days</button>
                </li>

                <li class="nav-item" role="presentation">
                  <button data-bs-toggle="tab" data-bs-target="#atab-6" type="button" role="tab" aria-controls="atab-6" aria-selected="false">50 days</button>
                </li>
              </ul>
              <!-- tabs nav -->

              <!-- tabs content -->
              <div class="tab-content">
                <div class="tab-pane fade show active" id="atab-5" role="tabpanel">
                  <div class="apool__content">
                    <span class="apool__value">$250 - $900</span>
                    <span class="apool__profit">Daily profit (%): <b>0.24</b></span>
                  </div>
                </div>

                <div class="tab-pane fade" id="atab-6" role="tabpanel">
                  <div class="apool__content">
                    <span class="apool__value">$350 - $1400</span>
                    <span class="apool__profit">Daily profit (%): <b>0.29</b></span>
                  </div>
                </div>
              </div>
              <!-- end tabs content -->

              <div class="apool__group">
                <label for="pool3" class="apool__label">Enter amount</label>
                <input id="pool3" name="pool3" type="text" class="apool__input">
              </div>

              <button class="apool__btn" data-bs-target="#modal-apool" type="button" data-bs-toggle="modal">Invest</button>

              <!-- design elements -->
              <span class="block-icon block-icon--blue">
							<i class="ti ti-database-dollar"></i>
						</span>
              <span class="screw screw--lines-tr"></span>
            </div>
            <!-- end arbitrage pool -->
          </div>
        </div>
      </div>
    </div>
    <!-- end arbitrage pools -->
  </div>
</template>

<style scoped>

</style>
